import ProjectDescriptionMetricsIdTranslations from './ProjectDescriptionMetricsIdTranslations';
export default class ProjectDescriptionMetricsId {
    constructor(projects) {
        const { id, value, translations } = projects;
        this.id = id;
        this.value = value ? value : '';
        this.translations = translations
            ? translations.map(translation => new ProjectDescriptionMetricsIdTranslations(translation))
            : [];
    }
}
